import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestConfirmDeleteAccount } from "application/deleteAccount/deleteAccountActions";
import { useHistory, useLocation } from "components/_hooks/useRouter";
import { getQueryStringParam } from "helpers/queryStringHelper";
import { isFailed, isFinished } from "helpers/requestStateHelper";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "routes";
import { oidc } from "services/oidcService";
import urlJoin from "url-join";

const confirmationTokenParamName = "confirmation-token";

export const DeleteAccountConfirmation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const deleteAccountConfirmation = useSelector(state => state.deleteAccount.deleteAccountConfirmation);
  useEffect(() => {
    const confirmationToken = getQueryStringParam(confirmationTokenParamName, location);
    dispatch(requestConfirmDeleteAccount(confirmationToken));
  }, []);

  useEffect(() => {
    if (isFinished(deleteAccountConfirmation)) {
      const oidcManager = oidc.getOidcManager();
      oidcManager.signout(urlJoin(window.location.origin, routes.accountDeleted));
    }
    if (isFailed(deleteAccountConfirmation)) {
      history.replace(routes.deleteAccountError);
    }
  }, [deleteAccountConfirmation]);

  return <Loader />;
};
